"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addVconsole = void 0;
/**
 * 添加调试工具
 * 调用方式：
 *  addVconsole();
 * 页面访问时添加参数debug=1
 */
var tools_1 = require("./tools");
var urlMethod_1 = require("./urlMethod");
var addVconsole = function () {
    if (urlMethod_1.getUrlParam("debug") && typeof window.vConsoleDemo == "undefined") {
        if (typeof VConsole === "undefined") {
            tools_1.loadScript({
                url: "//static.xgo-img.com.cn/mtouch/js/vconsole.min.js"
            }).then(function () {
                window.vConsoleDemo = new VConsole();
            });
        }
        else {
            window.vConsoleDemo = new VConsole();
        }
    }
};
exports.addVconsole = addVconsole;
